import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { easyKidsConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-currentaccount-easykids',
    template: ''
})
export class CurrentAccountEasyKids implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.url.subscribe((segments) => {
      let native = segments.some((seg) => seg.path === 'native');
      this.route.queryParams.subscribe(async (params) => {
        const inApp = params['inApp'];
        const code = params['code'];
        if (native && code) {
          easyKidsConfig.redirectUri =
            easyKidsConfig.redirectUri + '/native?code=' + code;
        } else if (!native && inApp && code) {
          easyKidsConfig.redirectUri =
            easyKidsConfig.redirectUri + '?inApp=true&code=' + code;
        } else if (!native && !inApp && code) {
          easyKidsConfig.redirectUri = easyKidsConfig.redirectUri + '?code=' + code;
        } else if (native && !inApp && !code) {
          easyKidsConfig.redirectUri = easyKidsConfig.redirectUri + '/native';
        } else if (!native && inApp && !code) {
          easyKidsConfig.redirectUri = easyKidsConfig.redirectUri + '?inApp=true';
        } else {
          easyKidsConfig.redirectUri = easyKidsConfig.redirectUri;
        }
      });
    });
  }

  ngOnInit(): void {
    this.loginService.login(easyKidsConfig);
  }
}
